/*
 * @Author: 邓宇芩 707208431@qq.com
 * @Date: 2025-11-11 15:35:49
 * @LastEditors: 邓宇芩 707208431@qq.com
 * @LastEditTime: 2026-06-04 10:01:53
 * @FilePath: \scanqrcode\src\api\orderQrcodeScanner.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 根据环境变量设置 API 基础路径
// 开发环境使用相对路径（通过 devServer proxy 代理）
// 生产环境使用完整的 API 地址
// 可以通过环境变量 VUE_APP_API_BASE_URL 覆盖默认配置
// 例如：VUE_APP_API_BASE_URL=/api/pc 或 VUE_APP_API_BASE_URL=https://artistsapi.beamco.co/star/api/pc
const BASE_URL = process.env.VUE_APP_API_BASE_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://artistsapi.beamco.co/star/api/pc'  // 生产环境使用完整地址
    : '/api/pc');

// 打印 API 配置，方便调试
if (process.env.NODE_ENV === 'development') {
  console.log('API BASE_URL (开发环境):', BASE_URL);
  console.log('代理配置: /api -> https://artistsapi.beamco.co/star');
} else {
  console.log('API BASE_URL (生产环境):', BASE_URL);
  console.log('提示: 如果遇到 CORS 错误，请确保后端服务器已配置 CORS 响应头');
  console.log('或者设置环境变量 VUE_APP_API_BASE_URL=https://artistsapi.beamco.co/star/api/pc');
}

function getStoredLanguage() {
  return localStorage.getItem("lang") || "en";
}

function getStoredToken() {
  return localStorage.getItem("auth_token") || "";
}

function setStoredToken(value) {
  if (value) {
    localStorage.setItem("auth_token", value);
  }
}

async function postRequest(
  endpoint,
  { body = {}, token, language, shouldStoreToken = false } = {}
) {
  const headers = {
    "Content-Type": "application/json",
  };

  const resolvedToken = token || getStoredToken();
  if (resolvedToken) {
    headers.Authorization = `Bearer ${resolvedToken}`;
  }

  const resolvedLanguage = language || getStoredLanguage();
  if (resolvedLanguage) {
    headers["lang"] = resolvedLanguage;
  }

  try {
    const response = await fetch(`${BASE_URL}/${endpoint}`, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
      // 添加 credentials 选项（如果需要发送 cookies）
      // credentials: 'include',
    });

    // 处理 CORS 错误
    if (response.type === 'opaque' || response.type === 'opaqueredirect') {
      throw new Error(
        'CORS 错误：服务器未正确配置 CORS 响应头。请联系后端开发人员配置以下响应头：\n' +
        'Access-Control-Allow-Origin: https://artists.beamco.co\n' +
        'Access-Control-Allow-Methods: POST, GET, OPTIONS\n' +
        'Access-Control-Allow-Headers: Content-Type, Authorization, Lang'
      );
    }

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Request failed: ${response.status} ${response.statusText} ${errorText}`
      );
    }

    const text = await response.text();
    if (!text) {
      throw new Error("Empty response body");
    }

    const data = JSON.parse(text);

    if (shouldStoreToken && data?.data?.accessToken) {
      setStoredToken(data.data.accessToken);
    }

    return data;
  } catch (error) {
    // 捕获网络错误（包括 CORS 错误）
    if (error.name === 'TypeError' && (error.message.includes('fetch') || error.message.includes('Failed to fetch'))) {
      console.error('网络请求失败，可能是 CORS 错误:', error);
      console.error('当前 API 地址:', BASE_URL);
      
      const isRelativePath = BASE_URL.startsWith('/');
      let errorMessage = '网络请求失败，可能是 CORS 错误。\n\n';
      
      if (isRelativePath) {
        errorMessage += '当前使用相对路径: ' + BASE_URL + '\n';
        errorMessage += '可能的原因：\n';
        errorMessage += '1. 前端服务器未配置反向代理\n';
        errorMessage += '2. 后端服务器未配置 CORS 响应头\n\n';
        errorMessage += '解决方案：\n';
        errorMessage += '方案1（推荐）：在前端服务器配置反向代理 /api -> https://artistsapi.beamco.co/star\n';
        errorMessage += '方案2：设置环境变量 VUE_APP_API_BASE_URL=https://artistsapi.beamco.co/star/api/pc 并确保后端配置 CORS\n';
        errorMessage += '方案3：联系后端开发人员配置 CORS 响应头\n\n';
        errorMessage += '详细配置说明请查看项目根目录的 CORS解决方案.md 文件';
      } else {
        errorMessage += '当前使用完整地址: ' + BASE_URL + '\n';
        errorMessage += '请确保后端服务器已配置以下 CORS 响应头：\n';
        errorMessage += 'Access-Control-Allow-Origin: https://artists.beamco.co\n';
        errorMessage += 'Access-Control-Allow-Methods: POST, GET, OPTIONS\n';
        errorMessage += 'Access-Control-Allow-Headers: Content-Type, Authorization, Lang\n\n';
        errorMessage += '详细配置说明请查看项目根目录的 CORS解决方案.md 文件';
      }
      
      throw new Error(errorMessage);
    }
    throw error;
  }
}

export function getScannerByKey({ urlKey, language }) {
  return postRequest("orderQrcodeScanner/getByKey", {
    body: { urlKey },
    language,
  });
}

export function loginScanner({ key, password, language }) {
  return postRequest("orderQrcodeScanner/login", {
    body: { key, password },
    language,
    shouldStoreToken: true,
  });
}

export function getScannerWebDetails({ id, token, language }) {
  return postRequest("orderQrcodeScanner/web-details", {
    body: { id },
    token,
    language,
  });
}

export function getStatistics({ shopItemId, token, language }) {
  return postRequest("qrcode/statistics", {
    body: { shopItemId },
    token,
    language,
  });
}

export function getList({ shopItemId, pageNum, pageSize, status, search, token, language }) {
  return postRequest("qrcode/web-list", {
    body: { shopItemId, pageNum, pageSize, status, search },
    token,
    language,
  });
}

export function scanQrcode({ qrcodeContext, token, language }) {
  return postRequest("qrcode/scanQrcode", {
    body: { qrcodeContext },
    token,
    language,
  });
}

export function redeemQrcode({ content, token, language }) {
  return postRequest("qrcode/redeemQrcode", {
    body: { content },
    token,
    language,
  });
}

// 导出 BASE_URL 供其他模块使用
export { BASE_URL };
